import type { ComponentType } from 'react';

import {
  createSearchFlowRoutes,
  loadLandingForgotPasswordRoute,
  loadLandingLoginRoute,
  loadLandingRegisterRoute,
} from '../shared/search-flow-routes';

const basePath = '/background-check';
const pageTitle = 'Background Checks & Public Records Search - DeepSearch';

const loadLanding = async (): Promise<{ Component: ComponentType }> => {
  const { BackgroundCheckLandingRoute } =
    await import('./LandingRoute/LandingRoute');
  return { Component: BackgroundCheckLandingRoute };
};

const loadSearchRoute = async (): Promise<{ Component: ComponentType }> => {
  const { SearchRoute } = await import('./SearchRoute/SearchRoute');
  return { Component: SearchRoute };
};

const { publicRoutes, protectedRoutes } = createSearchFlowRoutes({
  basePath,
  landingLoader: loadLanding,
  searchLoader: loadSearchRoute,
  loginLoader: loadLandingLoginRoute,
  registerLoader: loadLandingRegisterRoute,
  forgotPasswordLoader: loadLandingForgotPasswordRoute,
});

export const backgroundCheckRoutes = publicRoutes.map((route) => ({
  ...route,
  handle: { ...route.handle, pageTitle },
}));

export const protectedBackgroundCheckRoutes = protectedRoutes.map((route) => ({
  ...route,
  handle: { ...route.handle, pageTitle },
}));
